<div>
  <form novalidate #codeMaintForm="ngForm">
    <table>

      <tr>
        <td colspan="3">
          <kendo-grid #grid [kendoGridBinding]="glCodes"
                      [pageSize]="pageSize"
                      [resizable]="true" [pageable]="{
                            buttonCount: 5,
                            info: true,
                            type: 'numeric',
                            pageSizes: [20, 40, 60],
                            previousNext: true
                            }"
                            [sortable]="true"
                            [scrollable]="true"
                            (pageChange)="pageChange($event)"
                           [selectable]="{
                      mode: 'single',
                      checkboxOnly: true}"
                       (selectionChange)="allRowsSelected($event)"
                       [rowSelected]="isRowSelected"
                       [skip]="skip"
                       [kendoGridSelectBy]="selectionKey"
                       [selectedKeys]="selectedKeys"
                       (add)="addHandler($event)"
                       (edit)="editClicked($event)"
                       (save)="saveHandler($event)"
                      (cancel)="cancelClicked($event)"
                      (remove)="removeClicked($event)"
                      (cellClick)="gridCellClicked($event)"
                      [reorderable]="true"
                      [filterable]="true"
                      (excelExport)="excelExported($event)">
            <ng-template kendoGridToolbarTemplate>
              <div>GL Guide:
                <kendo-dropdownlist class=" guide-list" [data]="glguidedescriptions" [(ngModel)]="selectedValue"
                  name="selectedValue" (valueChange)="guideChange($event)">
                </kendo-dropdownlist>
              </div>

              <div class="gl-input">
                <div>
                  <kendo-floatinglabel text="GL Summary Sequence">
                    <input (ngModelChange)="newSummaryTextBoxChange($event)" [(ngModel)]="newSummaryTextValue"
                      name="seq" kendoTextBox style="  margin-bottom: 18px;
                      width: 161px;
                      height: 33px;" required/>
                  </kendo-floatinglabel>
                </div>
                <div>
                  <kendo-floatinglabel text="GL Code">
                    <input (ngModelChange)="newCodeTextBoxChange($event)" [(ngModel)]="newCodeTextValue" name="code"
                      kendoTextBox style="  margin-bottom: 18px;
                      width: 161px;
                      height: 33px;" required/>
                  </kendo-floatinglabel>
                </div>
                <div>
                  <kendo-floatinglabel text="GL Description">
                    <input (ngModelChange)="newDescriptionTextBoxChange($event)" [(ngModel)]="newDescriptionTextValue"
                      name="desc" kendoTextBox style="  margin-bottom: 18px;
                      width: 161px;
                      height: 33px;" required />
                  </kendo-floatinglabel>
                </div>
                <div>
                  <button kendoGridAddCommand type="app-mcl-button" primary="true" [disabled]="!isAddValid">Add</button>
                </div>
              </div>
              <div class="gl-print-btns" fxFlex fxLayout="row" fxLayoutAlign="end end">
                <app-mcl-button id="but-export" (buttonPressed)="exportToPDF(grid)" type="button" icon="file-pdf"
                  primary="true" text="Export to PDF"></app-mcl-button>

                <app-mcl-button id="but-export-excel" (buttonPressed)="exportToExcel(grid)" icon="file-excel" primary="true"
                  text="Export to Excel"></app-mcl-button>
                <kendo-grid-column-chooser style="float:right"></kendo-grid-column-chooser>
              </div>
            </ng-template>

            <kendo-grid-column field="glSequence" [width]="150" title="GL Sequence">
              <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                <input type="number" min="0" [(ngModel)]="dataItem.glSequence" name="glSequence" required />
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="glCode" [width]="150" title="GL Code">
              <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                <input type="number" min="0" [(ngModel)]="dataItem.glCode" name="glCode" required />
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="glDescription" [width]="200" title="GL Descriptions">
              <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                <input [(ngModel)]="dataItem.glDescription" name="glDescription" required />
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-command-column width="220">
              <ng-template kendoGridCellTemplate let-isNew="isNew">
                <button kendoGridEditCommand type="button" primary="true">Edit</button>
                <button kendoGridRemoveCommand type="button" primary="true">Remove</button>
                <button kendoGridSaveCommand type="button" primary="true"
                  [disabled]="codeMaintForm.invalid || codeMaintForm.pristine">Update</button>
                <button kendoGridCancelCommand type="button" primary="ture">Cancel</button>
              </ng-template>
            </kendo-grid-command-column>

            <!-- Pdf Export -->
            <kendo-grid-pdf fileName="GlCodeMaintenance.pdf" [author]="'McLane'" [producer]="'McLane'" paperSize="A4"
              [repeatHeaders]="false" [landscape]="true" [scale]="scale" [allPages]="true">
              <kendo-grid-column field="glSequence" title="GL Sequence">
              </kendo-grid-column>
              <kendo-grid-column field="glCode" title="GL Code">
              </kendo-grid-column>
              <kendo-grid-column field="glDescription" title="GL Description">
              </kendo-grid-column>
              <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
              <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                <div class="page-template">

                  <div class="header">
                    <div style="float: right">
                      Page {{ pageNum }} of {{ totalPages }}
                    </div>
                    <p>GL Guide Maintenance</p>
                  </div>

                </div>
              </ng-template>
            </kendo-grid-pdf>

            <!-- Excel Export -->
            <kendo-grid-excel fileName="GlCodeMaintenance.xlsx" [fetchData]="exportAllData">
              <kendo-excelexport-column field="glSequence" title="GL Sequence">
              </kendo-excelexport-column>
              <kendo-excelexport-column field="glCode" title="GL Code">
              </kendo-excelexport-column>
              <kendo-excelexport-column field="glDescription" title="GL Description">
              </kendo-excelexport-column>
            </kendo-grid-excel>

          </kendo-grid>
        </td>
      </tr>
      <tr>
        <td>

        </td>
      </tr>
    </table>

    <div kendoDialogContainer></div>
  </form>
</div>
